<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form ref="queryForm" class="formsearch" inline :model="listQuery" @submit.native.prevent>
        <el-form-item>
          <el-input v-model="listQuery.name" placeholder="请输入活畜名称1" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="listQuery.name" placeholder="请输入活畜名称2" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="listQuery.name" placeholder="请输入活畜名称3" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="listQuery.name" placeholder="请输入活畜名称4" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <template v-if="searchMore">
          <el-form-item>
            <el-input v-model="listQuery.name" placeholder="请输入活畜名称5" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
          </el-form-item>
          <el-form-item>
            <el-input v-model="listQuery.name" placeholder="请输入活畜名称6" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
          </el-form-item>
          <el-form-item>
            <el-input v-model="listQuery.name" placeholder="请输入活畜名称7" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
          </el-form-item>
          <el-form-item>
            <el-input v-model="listQuery.name" placeholder="请输入活畜名称8" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
          </el-form-item>
          <el-form-item>
            <el-input v-model="listQuery.name" placeholder="请输入活畜名称9" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
          </el-form-item>
          <el-form-item>
            <el-input v-model="listQuery.name" placeholder="请输入活畜名称" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
          </el-form-item>
          <el-form-item>
            <el-input v-model="listQuery.name" placeholder="请输入活畜名称" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
          </el-form-item>
          <el-form-item>
            <el-input v-model="listQuery.name" placeholder="请输入活畜名称" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
          </el-form-item>
        </template>
      </el-form>
      <div class="formbutton">
        <el-button type="primary" size="medium" icon="el-icon-search" @click="SearchData">搜索</el-button>
        <el-button type="info" plain size="medium" icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        <el-button type="text" @click="handleSearchMore">{{ searchMore ? '收起' : '展开' }} <i :class="searchMore?'el-icon-top':'el-icon-bottom'"></i></el-button>
      </div>
    </div>
    <!--
    <table-search :query="listQuery" @search="SearchData" @reset="resetQuery">
      <template #content>
        <el-form-item>
          <el-input v-model="listQuery.name" placeholder="请输入活畜名称1" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="listQuery.name" placeholder="请输入活畜名称2" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="listQuery.name" placeholder="请输入活畜名称3" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="listQuery.name" placeholder="请输入活畜名称4" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
      </template>
      <template #more-content>
        <el-form-item>
          <el-input v-model="listQuery.name" placeholder="请输入活畜名称5" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="listQuery.name" placeholder="请输入活畜名称6" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="listQuery.name" placeholder="请输入活畜名称7" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="listQuery.name" placeholder="请输入活畜名称8" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="listQuery.name" placeholder="请输入活畜名称9" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="listQuery.name" placeholder="请输入活畜名称" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="listQuery.name" placeholder="请输入活畜名称" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="listQuery.name" placeholder="请输入活畜名称" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
      </template>
    </table-search> -->

    <!-- <div class="filter-container">
      <el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
        <el-form-item>
          <el-input v-model="listQuery.name" placeholder="请输入活畜名称" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
        </el-form-item>
      </el-form>
    </div> -->
    <!--动作组-->
    <div class="action-container">
      <el-button-group>
        <!-- 弹窗层编辑 -->
        <el-button v-auth="'Animal.create'" class="action-item" type="primary" icon="el-icon-edit" @click="HandleCreate">添加</el-button>
        <el-button v-auth="'Animal.delete'" class="action-item" type="danger" icon="el-icon-delete" @click="BatchDelete">删除</el-button>
      </el-button-group>
    </div>
    <!--表开始-->
    <el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%" @sort-change="sortChange">
      <!--列开始-->
      <el-table-column type="selection" fixed="left" width="50"></el-table-column>
      <el-table-column align="center" prop="status" label="监管状态 " fixed="left" width="90"> </el-table-column>
      <el-table-column align="center" prop="" label="监管方式 " fixed="left" width="100"> </el-table-column>
      <el-table-column align="center" prop="realname" label="被监管方 " width="150"> </el-table-column>
      <el-table-column align="center" prop="phone" label="联系电话 " width="110"> </el-table-column>
      <el-table-column align="center" prop="loan.bank_name " label="委托方 " width="200">
        <template slot-scope="scope">
          {{ scope.row.loan.bank_name || '' }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="creator_name" label="客户经理 " width="110"> </el-table-column>
      <el-table-column align="center" prop="" label="监管员 " width="110"> </el-table-column>
      <el-table-column align="center" label="监管时间 " width="190">
        <template slot-scope="scope">
          <span v-if="scope.row.start_time">{{ scope.row.start_time || '' }} 至 {{ scope.row.end_time || '' }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="loan_deadline" label="监管周期（月） " width="130">
        <template slot-scope="scope">
          {{ scope.row.loan.loan_deadline || '' }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="credit_amount" label="授信金额(万元) " width="140"> </el-table-column>
      <el-table-column align="center" prop="service_charge" label="服务费金额(元) " width="150"> </el-table-column>
      <el-table-column align="center" prop="mortgage_animal" label="抵押活畜数量(头) " width="160"> </el-table-column>
      <el-table-column align="center" prop="mortgage_amount" label="抵押活畜总价值(万元) " width="190"> </el-table-column>
      <el-table-column align="center" prop="order_number" label="监管单号 " width="170"> </el-table-column>
      <el-table-column align="center" prop="" label="耳标情况 " width="80"> </el-table-column>
      <el-table-column align="center" prop="" label="保险单到期日期 " width="150"> </el-table-column>
      <el-table-column align="center" prop="" label="监管主体 " width="150"> </el-table-column>
      <el-table-column align="center" prop="create_time" label="创建时间 " width="160"> </el-table-column>
      <el-table-column align="center" prop="" label="备注说明 " width="150"> </el-table-column>
      <el-table-column align="center" prop="" label="操作" width="320" fixed="right" class-name="action">
        <template slot-scope="scopes">
          <el-button v-auth="'Animal.update'" size="mini" type="primary" icon="el-icon-info" @click="HandleUpdate(scopes.row)">详情</el-button>
          <el-button v-auth="'Animal.delete'" icon="el-icon-video-play" type="success" size="mini" @click="RowDelete(scopes.row)">视频</el-button>
          <el-button v-auth="'Animal.delete'" icon="el-icon-circle-close" type="danger" size="mini" @click="RowDelete(scopes.row)">关闭</el-button>

          <el-popover
            placement="left"
            width="260"
            trigger="click"
            style="margin-left:10px;"
          >
            <div style="display: flex;justify-content: space-between;flex-wrap: wrap;padding:0 15px;">

              <el-tooltip popper-class="custom-tooltip" effect="dark" content="分佣规则" placement="top">
                <el-button type="text" icon="el-icon-watermelon" class="popover-button">分佣</el-button>
              </el-tooltip>
              <el-tooltip popper-class="custom-tooltip" effect="dark" content="巡检设置" placement="top">
                <el-button type="text" icon="el-icon-dish" class="popover-button">巡检</el-button>
              </el-tooltip>
              <el-tooltip popper-class="custom-tooltip" effect="dark" content="上传/查看附件" placement="top">
                <el-button type="text" icon="el-icon-folder-opened" class="popover-button">附件</el-button>
              </el-tooltip>
              <el-tooltip popper-class="custom-tooltip" effect="dark" content="续单" placement="top">
                <el-button type="text" icon="el-icon-eleme" class="popover-button">续单</el-button>
              </el-tooltip>
              <el-tooltip popper-class="custom-tooltip" effect="dark" content="修改服务费" placement="top">
                <el-button type="text" icon="el-icon-cold-drink" class="popover-button">服务费</el-button>
              </el-tooltip>
              <el-tooltip popper-class="custom-tooltip" effect="dark" content="上传/查看保险单" placement="top">
                <el-button type="text" icon="el-icon-date" class="popover-button">保险单</el-button>
              </el-tooltip>
              <el-tooltip popper-class="custom-tooltip" effect="dark" content="修改监管员" placement="top">
                <el-button type="text" icon="el-icon-coordinate" class="popover-button">监管员</el-button>
              </el-tooltip>
              <el-tooltip popper-class="custom-tooltip" effect="dark" content="修改紧急联系人" placement="top">
                <el-button type="text" icon="el-icon-s-custom" class="popover-button">联系人</el-button>
              </el-tooltip>
              <el-tooltip popper-class="custom-tooltip" effect="dark" content="预警参数" placement="top">
                <el-button type="text" icon="el-icon-alarm-clock" class="popover-button">预警参数</el-button>
              </el-tooltip>
              <el-tooltip popper-class="custom-tooltip" effect="dark" content="上传视频" placement="top">
                <el-button type="text" icon="el-icon-video-camera-solid" class="popover-button">上传视频</el-button>
              </el-tooltip>
              <el-tooltip popper-class="custom-tooltip" effect="dark" content="完善耳标" placement="top">
                <el-button type="text" icon="el-icon-setting" class="popover-button">完善耳标</el-button>
              </el-tooltip>

            </div>
            <el-button slot="reference" icon="el-icon-more" type="info" size="mini"></el-button>
          </el-popover>
        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="loadData" />
    <!--弹窗编辑/新增窗体-->
    <el-dialog :title="dialogStatus=='create'?'新增':'编辑'" :visible.sync="dialogFormVisible">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="110px" style="width: 100%;">
        <el-form-item label="活畜名称" prop="name">
          <el-input v-model="temp.name" />
        </el-form-item>
        <el-form-item label="单位" prop="unit">
          <el-input v-model="temp.unit" />
        </el-form-item>
        <el-form-item label="排序" prop="order_no">
          <el-input-number v-model="temp.order_no" :min="1" label="描述文字"></el-input-number>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="ConfirmData">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/supervision/animal' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
import dict_data from '@/api/system/dict_data'
import TableSearch from '@/components/TableSearch/index'

export default {
  name: 'Animal',
  components: { Pagination, TableSearch },
  // 列绑定格式化器
  filters: {

  },
  mixins: [commonList],
  data() {
    return {
      // api接口方法
      api,
      // 校验
      rules: {
      },
      temp: {},
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: 'desc', // 默认排序方式,
        sort: 'id'
      },
      show: true,
      // 字典参数
      dictionary: []
      // 字典参数
    }
  },
  created() {
    this.loadData()
    dict_data.Drop({ sort: 'sort', order: 'asc', isPaginator: false, dict_code: '' }).then(response => {
      this.dictionary = response.data
    })
  },
  methods: {
    SearchData() {
      console.log(this.listQuery, '-------------')
    },
    resetQuery() {
      this.resetForm('queryForm')
      console.log(this.listQuery, '-------=========------')
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        order_no: 99999,
        name: '',
        unit: ''
      }
    }

  }
}
</script>
<style scoped>
.popover-button{
  width:35%;
  text-align: left;
  margin:5px 8px;
}
.action-container{
  /* display: flex;
  justify-content: flex-end; */
}
</style>
